import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { Component, Input } from '@angular/core';

import { MyModal } from './../../../../../common/my-modal/my-modal.component';
import { HtmlService } from './../../../../../../services/html.service';

@Component({
    selector: 'ipp-writing-sample-response',
    template: require('./ipp-writing-sample-response.component.html')
})
export class IppWritingSampleResponseComponent {
    @Input() title: string;
    @Input() resourceId: number;

    constructor(
        private myModal: MyModal,
        private htmlService: HtmlService
    ) {

    }

    showDialog() {
        this.htmlService.getHtmlResource(this.resourceId).subscribe(html => {
            this.myModal.showRegularDlg(this.title, html, [
                { label: "Close", style: "btn-primary" }
            ]);
        });
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-writing-sample-response/ipp-writing-sample-response.component.ts